import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, FormHelperText,
    CircularProgress
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { MaterialMaster } from '../TitleList';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { fetchMaterialData } from '../../Store/PHPSlice/Material';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { createMatInwardEntry } from '../../Store/PHPSlice/MatInward';
import { errorStyles } from '../../Utils/table';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { selectFirm, selectlocationdata } from '../Selectors/Master/ItemSelectors';

import { fetchLocationData } from '../../Store/PHPSlice/Transport';
import { useParams } from 'react-router-dom';
import axios from 'axios';


const NewMatInwEntry = () => {
    const { Id } = useParams();
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        materialNm: Id,
        inwardNo: "",
        locationId: "",
        userId: userdata?.ID
    });
    const [errors, setErrors] = useState({});
    const [tableRows, setTableRows] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);

    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const materials = useSelector((state) => state.MaterialData.material || { data: [] });
    const locations = useSelector(selectlocationdata);

    useEffect(() => {
        dispatch(fetchMaterialData())
        dispatch(fetchLocationData())
    }, [dispatch]);

    useEffect(() => {
        if (!formData.inwardNo) return;

        const timer = setTimeout(async () => {
            try {
                const response = await axios.get(
                    `${baseUrl}?apicall=validation_material_inwardNo&inwardNo=${formData.inwardNo}`
                );

                // console.log(response.data);

                if (response.data.status === "exists") {
                    alert(response.data.msg || "Inward number already exists");
                    window.location.reload();
                }

            } catch (error) {
                console.error("error", error);
            }
        }, 500); // 500ms delay after typing stops

        return () => clearTimeout(timer); // cleanup
    }, [formData.inwardNo]);

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleAddMaterial = () => {
        const selectedMaterial = materials?.data?.find(item => item.ID === formData.materialNm);
        // console.log(selectedMaterial)
        const locNm = locations?.data?.find(i => i.ID === formData.locationId)?.locNm;
        if (selectedMaterial) {
            setTableRows([
                ...tableRows,
                {
                    id: tableRows.length + 1,
                    materialId: selectedMaterial.ID,
                    materialNm: selectedMaterial.materialNm,
                    description: selectedMaterial.description || '',
                    size: selectedMaterial.size || '',
                    locNm: locNm || '',
                    locId: formData.locationId || '',
                    hsn: selectedMaterial.hsn || '',
                    mtype: selectedMaterial.mtype || '',
                    ptype: selectedMaterial.ptype || '',
                    // packets: selectedMaterial.packets || '',
                    // packetqty: selectedMaterial.packetqty || '',
                    packets: selectedMaterial.packetqty || '',
                    packetqty: selectedMaterial.mqty || '',
                    totqty: '',
                    stkqty: '',
                    inwqty: '',
                    totmtr: '',
                    totinches: ''
                }
            ]);
        }

        setFormData({
            ...formData,
            materialNm: '',
            locationId: ''
        })
    };

    // const handleInputChange = (index, field, value) => {
    //     const updatedRows = tableRows.map((row, i) => {
    //         if (i === index) {
    //             return { ...row, [field]: value.toUpperCase() };
    //         }
    //         return row;
    //     });
    //     setTableRows(updatedRows);
    // };

    const handleInputChange = (index, field, value) => {
        const updatedRows = tableRows.map((row, i) => {
            if (i !== index) return row;

            const updatedRow = {
                ...row,
                [field]: Number(value) || 0
            };

            const perPacketQty = Number(updatedRow.packets) || 0;
            const measureqty = Number(updatedRow.packetqty) || 0;
            const stockQty = Number(updatedRow.stkqty) || 0;
            const inwqty = Number(updatedRow.inwqty) || 0;

            const boxrollqty = (measureqty * perPacketQty).toFixed(2);
            // TOTAL QTY


            // INCHES calculation (only for MTR / INCH)
            const mtype = updatedRow.mtype?.toLowerCase();

            const oneInch = 39.3701;
            if (mtype === 'mtr') {
                updatedRow.totqty = (boxrollqty * inwqty).toFixed(2);
                updatedRow.totinches = (updatedRow.totqty * oneInch).toFixed(2);
            } else if (mtype === 'inch') {
                updatedRow.totinches = (boxrollqty * inwqty).toFixed(2);
                updatedRow.totqty = (updatedRow.totinches / oneInch).toFixed(2);
            }
            else {
                updatedRow.totqty = (boxrollqty * inwqty).toFixed(2);
                updatedRow.totinches = 0;
            }

            // if (mtype === 'inch' || mtype === 'mtr' || mtype === 'roll') {
            //     updatedRow.inches = (updatedRow.totqty * 39.3701).toFixed(2);
            // } else {
            //     updatedRow.inches = 0;
            // }

            return updatedRow;
        });

        setTableRows(updatedRows);
    };

    const handleCheckboxChange = (rowId) => {
        if (selectedRows.includes(rowId)) {
            setSelectedRows(selectedRows.filter(id => id !== rowId));
        } else {
            setSelectedRows([...selectedRows, rowId]);
        }
    };

    const handleDeleteMaterial = () => {
        setTableRows(tableRows.filter(row => !selectedRows.includes(row.id)));
        setSelectedRows([]);
    };

    // const validate = () => {
    //     const newErrors = {};
    //     // if (!formData.materialNm) newErrors.materialNm = 'Material Name is required';
    //     return newErrors;
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // const validationErrors = validate();
        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        //     return;
        // }
        if (tableRows.length > 0) {

            setLoading(true);

            // var finalObject = {
            //     dt: formData.dt,
            //     inwardNo: formData.inwardNo,
            //     locationId: formData.locationId,
            //     matId: tableRows.map(row => row.materialId),
            //     pkt: tableRows.map(row => row.packets),
            //     packetqty: tableRows.map(row => row.packetqty),
            //     totqty: tableRows.map(row => row.totqty),
            //     qty: tableRows.map(row => row.stkqty),
            //     inches: tableRows.map(row => Number(row.inches)),
            //     mtype: tableRows.map(row => row.mtype),   // ✅ ADD THIS
            //     userId: formData.userId
            // };

            var finalObject = {
                dt: formData.dt,
                inwardNo: formData.inwardNo,
                userId: formData.userId,
                tableRows: tableRows
            };

            try {
                const result = await dispatch(createMatInwardEntry(finalObject)).unwrap();
                console.log('POST request successful!', result);
                // alert("Material Inward Added");
                // window.close();

                if (result.status === "success") {
                    alert(result.msg);
                    // window.opener.postMessage("REFRESH_PARENT", "*");
                    window.close();
                } else {
                    const msg = Array.isArray(result.msg) ? result.msg.join("\n") : result.msg;
                    alert(msg);
                }
            } catch (error) {
                console.error('Error while making POST request:', error);
            } finally {
                setLoading(false);
            }

        } else {
            alert("Select Material Name & fill the Table");

        }

    };

    const dropdownlist = [
        //  ✅ LOCATION DROPDOWN
        {
            label: 'Location',
            id: 'locationId',
            options: locations?.data || [],
            value: formData.locationId,
            onChange: (newValue) =>
                handleDropdownChange(
                    { target: { name: 'locationId', value: newValue ? newValue.ID : '' } },
                    'locationId'
                ),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) =>
                options.find(item => item.ID === value) || null,
            errors: errors.locationId
        },

        {
            label: 'Material',
            id: 'materialNm',
            options: materials?.data || [],
            value: formData.materialNm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'materialNm', value: newValue ? newValue.ID : '' } }, 'materialNm'),
            getOptionLabel: (option) => `${option.materialNm}-${option.size}` || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            errors: errors.materialNm
        },
    ];

    return (
        <>
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Material Inward Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>
                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='dt' >Date:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id='dt'
                                                    name='dt'
                                                    type='date'
                                                    value={formData.dt}
                                                    onChange={handleDateChange}
                                                    inputProps={{ style: styled.inputDate }}
                                                    sx={inputStyles}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {/* Inward No */}
                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor="inwardNo">Inward No:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id="inwardNo"
                                                    name="inwardNo"
                                                    type="text"
                                                    value={formData.inwardNo}
                                                    onChange={(e) =>
                                                        setFormData({ ...formData, inwardNo: e.target.value })
                                                    }
                                                    inputProps={{ style: styled.inputTable }}
                                                    sx={inputStyles}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                            <InputLabel id="materialNm">Material Name :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="materialNm"
                                                    id="materialNm"
                                                    name="materialNm"
                                                    value={formData.materialNm}
                                                    onChange={(e) => handleDropdownChange(e, 'materialNm')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value=" ">Select an option</MenuItem>
                                                    {
                                                        materials.data.length > 0 ? materials.data.map((item, index) => (
                                                            <MenuItem value={item.ID}>{item.materialNm} - {item.size}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                                {errors.materialNm && <FormHelperText style={errorStyles}>{errors.materialNm}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                {dropdownlist?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here

                                        errors={drop.errors}
                                    />
                                ))
                                }


                                <Grid item xs={12} md={6}>
                                    <Button variant="contained" color="primary" onClick={handleAddMaterial} sx={{ mr: 2 }} disabled={formData.materialNm === "" || formData.locationId === ""}>Add </Button>
                                    <Button variant="contained" color="primary" onClick={handleDeleteMaterial} disabled={selectedRows.length === 0}>Delete</Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ marginTop: '1%' }}>
                                        <TableContainer width={400}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Select</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Location</TableCell>

                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Material Name</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Size</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>HSN</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>M. Qty</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>M.Type</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Per Packet Qty/Mtr</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>P. Type</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Inward Qty.</TableCell>
                                                        {/* <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Total Qty</TableCell> */}
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Meter / Qty.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Inches</TableCell>

                                                        {/* <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Stock Qty</TableCell> */}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableRows.map((row, index) => (
                                                        <TableRow key={row.id}>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                <Checkbox
                                                                    checked={selectedRows.includes(row.id)}
                                                                    onChange={() => handleCheckboxChange(row.id)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{row.id}</TableCell>

                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                {row.locNm}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                {row.materialNm}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                {row.size}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                {row.hsn}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                <TextField
                                                                    value={row.packetqty}
                                                                    onChange={(e) => handleInputChange(index, 'packetqty', e.target.value)}

                                                                    sx={{
                                                                        width: 80,
                                                                        '& input': {
                                                                            textAlign: 'center',
                                                                            fontWeight: 'bold',
                                                                            color: 'green'
                                                                        }
                                                                    }}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                {row.mtype}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                <TextField
                                                                    value={row.packets}
                                                                    onChange={(e) => handleInputChange(index, 'packets', e.target.value)}

                                                                    sx={{
                                                                        width: 80,
                                                                        '& input': {
                                                                            textAlign: 'center',
                                                                            fontWeight: 'bold',
                                                                            color: 'green'
                                                                        }
                                                                    }}
                                                                />

                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                {row.ptype}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align="center">
                                                                <TextField
                                                                    size="small"
                                                                    value={row.inwqty}   // ✅ CORRECT FIELD
                                                                    onChange={(e) =>
                                                                        handleInputChange(index, 'inwqty', e.target.value)
                                                                    }
                                                                    sx={{
                                                                        width: 80,
                                                                        '& input': {
                                                                            textAlign: 'center',
                                                                            fontWeight: 'bold'
                                                                        }
                                                                    }}
                                                                />
                                                            </TableCell>

                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                <TextField
                                                                    size="small"
                                                                    value={row.totqty}
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: {
                                                                            ...styled.inputTable,
                                                                            color: 'blue',
                                                                            fontWeight: 'bold',
                                                                            width: 80
                                                                        }
                                                                    }}
                                                                    variant="standard"
                                                                />
                                                            </TableCell>

                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                <TextField
                                                                    value={row.totinches}
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: {
                                                                            ...styled.inputTable,
                                                                            color: 'purple',
                                                                            fontWeight: 'bold',
                                                                            width: 100
                                                                        }
                                                                    }}
                                                                    variant="standard"
                                                                />
                                                            </TableCell>

                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </Grid>
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default NewMatInwEntry;
